import React from "react";

const ProgressHeader = ({ title, nextTitle, currentStep, totalSteps }) => {
  const progressPercentage = (currentStep / totalSteps) * 100;

  return (
    <div className="absolute bottom-0 z-50 w-full font-langit text-white">
      <div className="px-4 sm:px-6 md:px-16 flex justify-between tracking-wider items-center text-[12px] md:text-[20px] lg:text-[30px]  mb-2">
        <p>
          <span className="text-[#919191] uppercase">{title}</span> {nextTitle}
        </p>
        <button className="bg-[#282828] text-white px-6 sm:px-8 py-2 rounded-3xl tracking-widest font-langit text-[12px] md:text-[15px] lg:text-[20px] border-none">
          <span className="text-[#F58220]">
            {String(currentStep).padStart(2, "0")}
          </span>
          /{String(totalSteps).padStart(2, "0")}
        </button>
      </div>
      <div className="w-full ">
        <div className="w-full h-[3px] bg-[#949494]  overflow-hidden">
          <div
            className="h-full bg-[#F58220] transition-all duration-500 ease-in-out"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default ProgressHeader;
